export default __webpack_public_path__ + "static/media/benefit_13@3x.c6cdb2c6.png";